import { datadogRum } from "@datadog/browser-rum";
import { hasStatisticsConsent } from "./cookieConsent";

/**
 * Sync Datadog RUM + session replay with Cookiebot statistics consent.
 * RUM is Statistics (non-essential), not Necessary.
 * @returns {void}
 */
export function applyDatadogTrackingConsent(): void {
  if (hasStatisticsConsent()) {
    datadogRum.setTrackingConsent("granted");
    datadogRum.startSessionReplayRecording();
    return;
  }
  datadogRum.setTrackingConsent("not-granted");
  datadogRum.stopSessionReplayRecording();
}

/**
 * Wire Cookiebot consent events to Datadog RUM (call once at app boot).
 * @returns {void}
 */
export function bindDatadogToCookiebotConsent(): void {
  applyDatadogTrackingConsent();
  window.addEventListener(
    "CookiebotOnConsentReady",
    applyDatadogTrackingConsent,
  );
  window.addEventListener("CookiebotOnAccept", applyDatadogTrackingConsent);
  window.addEventListener("CookiebotOnDecline", applyDatadogTrackingConsent);
}
